import type { RouteRecord } from "vite-react-ssg";
import Layout from "./Layout";
import Index from "./pages/Index";

// Adapt a default-exporting page module to react-router's `lazy` contract.
const page = (loader: () => Promise<{ default: React.ComponentType }>) =>
  async () => ({ Component: (await loader()).default });

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Index /> },
      { path: "submit-request", lazy: page(() => import("./pages/SubmitRequest")) },
      { path: "privacy", lazy: page(() => import("./pages/Privacy")) },
      { path: "terms", lazy: page(() => import("./pages/Terms")) },
      { path: "ai-automation-agency", lazy: page(() => import("./pages/AiAutomationAgency")) },
      { path: "ai-automation-consultant", lazy: page(() => import("./pages/AiAutomationConsultant")) },
      { path: "business-automation-services", lazy: page(() => import("./pages/BusinessAutomationServices")) },
      { path: "workflow-automation-services", lazy: page(() => import("./pages/WorkflowAutomationServices")) },
      { path: "ai-website-optimization", lazy: page(() => import("./pages/AiWebsiteOptimization")) },
      { path: "philadelphia-ai-automation", lazy: page(() => import("./pages/PhiladelphiaAiAutomation")) },
      { path: "delaware-business-automation", lazy: page(() => import("./pages/DelawareBusinessAutomation")) },
      { path: "blog/what-does-an-ai-automation-agency-do", lazy: page(() => import("./pages/blog/WhatDoesAnAiAutomationAgencyDo")) },
      { path: "blog/ai-automation-agency-pricing", lazy: page(() => import("./pages/blog/AiAutomationAgencyPricing")) },
      { path: "blog/best-automations-for-service-businesses", lazy: page(() => import("./pages/blog/BestAutomationsForServiceBusinesses")) },
      { path: "blog/ai-automation-consultant-vs-agency-vs-in-house", lazy: page(() => import("./pages/blog/AiAutomationConsultantVsAgency")) },
      { path: "blog/how-to-choose-an-automation-consultant", lazy: page(() => import("./pages/blog/HowToChooseAnAutomationConsultant")) },
      { path: "blog/90-day-automation-roadmap", lazy: page(() => import("./pages/blog/NinetyDayAutomationRoadmap")) },
      { path: "blog/workflow-automation-examples-real-estate", lazy: page(() => import("./pages/blog/WorkflowAutomationExamplesRealEstate")) },
      { path: "blog/workflow-automation-examples-insurance", lazy: page(() => import("./pages/blog/WorkflowAutomationExamplesInsurance")) },
      { path: "blog/workflow-automation-examples-mortgage", lazy: page(() => import("./pages/blog/WorkflowAutomationExamplesMortgage")) },
      { path: "blog/zapier-vs-make", lazy: page(() => import("./pages/blog/ZapierVsMake")) },
      { path: "blog/how-to-document-a-workflow", lazy: page(() => import("./pages/blog/HowToDocumentAWorkflow")) },
      { path: "blog/ai-website-optimization-checklist", lazy: page(() => import("./pages/blog/AiWebsiteOptimizationChecklist")) },
      { path: "blog/how-to-make-your-website-llm-ready", lazy: page(() => import("./pages/blog/HowToMakeYourWebsiteLlmReady")) },
      { path: "blog/service-page-template", lazy: page(() => import("./pages/blog/ServicePageTemplate")) },
      { path: "*", lazy: page(() => import("./pages/NotFound")) },
    ],
  },
];
